<template>
      <div id="spinner" :class="[show ? '' : 'is-hidden']">
          <div class="columns is-mobile is-centered is-vcentered is-full-height">
              <div class="column">
                  <div class="columns is-mobile is-centered">
                      <div class="column is-two-thirds has-text-centered">
                          <img id="logo" src="/img/logo.png" alt="eWATER Services"><br />
                          <img id="loading" src="/img/spinner.svg" alt="eWATER Services">
                      </div>
                  </div>
              </div>
          </div>
      </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Spinner",
  props:
  {
    show: Boolean
  }
};
</script>
